import messages from '../../../locale/messages';

const validate = values => {
    const errors = {};

    if (!values.firstName) {
        errors.firstName = messages.required;
    } else if (values.firstName.trim() == "") {
        errors.firstName = messages.required;
    } else if (values.firstName && (values.firstName.length < 3 || values.firstName.length > 20)) {
        errors.firstName = messages.firstnameValidate;
    }

    if (!values.lastName) {
        errors.lastName = messages.required;
    } else if (values.lastName.trim() == "") {
        errors.lastName = messages.required;
    } else if (values.lastName && (values.lastName.length < 3 || values.lastName.length > 20)) {
        errors.lastName = messages.lastnameValidate;
    }

    if (!values.email) {
        errors.email = messages.required;
    } 


    if (!values.password) {
        // errors.password = messages.required;
    } else if (values.password.length < 8) {
        errors.password = messages.passwordInvalid;
    }

    if (!values.phoneNumber) {
        errors.phoneNumber = messages.required;
    } else if (!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(values.phoneNumber)) {
        errors.phoneNumber = messages.phoneError;
    }

    if (!values.phoneDialCode) {
        errors.phoneDialCode = messages.required;
    }

    return errors;
};

export default validate